export const google_vertexModels = {
    id: "google-vertex",
    name: "Vertex",
    npm: "@ai-sdk/google-vertex",
    doc: "https://cloud.google.com/vertex-ai/generative-ai/docs/models",
    env: [
        "GOOGLE_VERTEX_PROJECT",
        "GOOGLE_VERTEX_LOCATION",
        "GOOGLE_APPLICATION_CREDENTIALS",
    ],
    models: {
        "gemini-2.5-flash-preview-05-20": {
            id: "gemini-2.5-flash-preview-05-20",
            name: "Gemini 2.5 Flash Preview 05-20",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-05-20",
            last_updated: "2025-05-20",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.6,
                cache_read: 0.0375,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "gemini-2.5-pro": {
            id: "gemini-2.5-pro",
            name: "Gemini 2.5 Pro",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-03-20",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "gemini-2.0-flash-lite": {
            id: "gemini-2.0-flash-lite",
            name: "Gemini 2.0 Flash Lite",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.075,
                output: 0.3,
            },
            limit: {
                context: 1048576,
                output: 8192,
            },
        },
        "gemini-2.5-flash": {
            id: "gemini-2.5-flash",
            name: "Gemini 2.5 Flash",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-17",
            last_updated: "2025-06-17",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 2.5,
                cache_read: 0.075,
                cache_write: 0.383,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "gemini-2.5-pro-preview-06-05": {
            id: "gemini-2.5-pro-preview-06-05",
            name: "Gemini 2.5 Pro Preview 06-05",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-05",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "gemini-2.5-pro-preview-05-06": {
            id: "gemini-2.5-pro-preview-05-06",
            name: "Gemini 2.5 Pro Preview 05-06",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-05-06",
            last_updated: "2025-05-06",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "gemini-2.0-flash": {
            id: "gemini-2.0-flash",
            name: "Gemini 2.0 Flash",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.1,
                output: 0.4,
                cache_read: 0.025,
            },
            limit: {
                context: 1048576,
                output: 8192,
            },
        },
        "gemini-2.5-flash-lite-preview-06-17": {
            id: "gemini-2.5-flash-lite-preview-06-17",
            name: "Gemini 2.5 Flash Lite Preview 06-17",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-17",
            last_updated: "2025-06-17",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.1,
                output: 0.4,
                cache_read: 0.025,
            },
            limit: {
                context: 65536,
                output: 65536,
            },
        },
        "gemini-2.5-flash-preview-04-17": {
            id: "gemini-2.5-flash-preview-04-17",
            name: "Gemini 2.5 Flash Preview 04-17",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-04-17",
            last_updated: "2025-04-17",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.6,
                cache_read: 0.0375,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
    },
};
export default google_vertexModels;
//# sourceMappingURL=google-vertex.js.map